/* Cover-frame swap for the PDP gallery (BW-212 markup, BW-213 rehydration).
 *
 * One delegated click listener, bound once. Resolves the cover image and the
 * thumbnail set relative to the nearest .pdp-gallery ancestor (BW-442: a
 * multi-copy title renders one gallery per copy, only one visible) rather than the
 * global #pdp-cover-img id, because the BW-213 modal can have a second
 * .pdp-table (the mounted fragment) in the same document as the real PDP's
 * own - loaded by snippets/product-table.liquid itself, so it works
 * identically in both places with no init call needed.
 */
(function () {
  "use strict";

  document.addEventListener("click", function (e) {
    var thumb = e.target.closest ? e.target.closest(".pdp-thumb") : null;
    if (!thumb) return;
    var table = thumb.closest(".pdp-gallery");
    if (!table) return;
    var img = table.querySelector(".pdp-cover-frame img");
    if (!img) return;

    img.src = thumb.getAttribute("data-full");
    if (thumb.getAttribute("data-srcset")) {
      img.srcset = thumb.getAttribute("data-srcset");
    } else {
      img.removeAttribute("srcset");
    }

    var thumbs = table.querySelectorAll(".pdp-thumb");
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.remove("is-active");
      thumbs[i].setAttribute("aria-selected", "false");
    }
    thumb.classList.add("is-active");
    thumb.setAttribute("aria-selected", "true");
  });
})();
